import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { styled, Typography } from '@mui/material';
import { getCollectionHandle } from '../../utils/utils';
import {
    NavigationMenuItem,
    DesktopMenuItemProps,
} from '../../models/NavigationMenuItem';

const MainLinkStyled = styled(Typography)(() => ({
    fontSize: '13px',
    fontWeight: '700',
}));

const ChildLinkStyled = styled(Typography)(() => ({
    fontSize: '13px',
    fontWeight: '400',
}));

export const NavigationItemContent: FC<DesktopMenuItemProps> = (props) => {
    const menuItem = props.menuItem;

    const setUrl = (item): string => {
        return item.type == 'COLLECTION'
            ? 'collections/' + getCollectionHandle(item.url)
            : getCollectionHandle(item.url);
    };

    return (
        <>
            <Link to={setUrl(menuItem)} onClick={props.clickHandler}>
                <MainLinkStyled>{menuItem.title.toUpperCase()}</MainLinkStyled>
            </Link>
            {menuItem.items.map((item: NavigationMenuItem) => (
                <Link
                    to={setUrl(item)}
                    key={item.id}
                    onClick={props.clickHandler}
                >
                    <ChildLinkStyled>{item.title}</ChildLinkStyled>
                </Link>
            ))}
        </>
    );
};
